import http from '~/http/index';

export default ({
  state: {
    data: [],
    additionalData: {},
    referrer: {},
    filters: {},
    sort: {
      sort: 'active',
      sortDesc: true,
    },
    page: 1,
    pages: 0,
    filterLists: {
      arrayList: [
        { id: 0, caption: 'Caption' },
      ],
    },
  },

  getters: {
    requestData(state, _getters, rootState, rootGetters) {
      const { filters, sort, page } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const { id } = rootState.user.user;
      return {
        userIdList: [id],
        ...filters,
        ...sort,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
        getTotal: true,
      };
    },
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_SORT(state, data) { state.sort = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },

    SET_DATA(state, data) {
      state.data = data;
    },

    SET_ADDITIONAL_DATA(state, data) {
      state.additionalData = data;
    },

    SET_REFERRER(state, data) {
      state.referrer = data;
    },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setSort({ commit }, data) { commit('SET_SORT', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadData({ getters, commit, rootGetters }, data) {
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const response = await http.post('v2/Referral/GetReferralPrograms', {
        ...getters.requestData,
        ...data,
      });
      const { items, cumulativeCurrencyTitle, total } = response.data;
      commit('SET_DATA', items);
      commit('SET_ADDITIONAL_DATA', { cumulativeCurrencyTitle });
      if (total) {
        const pages = Math.ceil(total / itemsPerPage);
        commit('SET_PAGES', pages);
      }
    },

    async getReferralsByParams(__store, data) {
      const response = await http.post('v2/Referral/GetReferrals', data);
      return response.data;
    },

    async updateReferralProgram(__store, data) {
      const response = await http.post('v2/Referral/UpdateReferralProgram', data);
      return response.data;
    },

    async loadUserReferrer({ state, commit, rootState }) {
      const { id } = rootState.user.user;
      const response = await http.post('v2/Referral/GetReferralPrograms', {
        referralIdList: [id],
        cumulativeCurrencyId: state.filters.cumulativeCurrencyId,
      });
      const { items } = response.data;
      if (items && items.length) {
        const item = items[0];
        commit('SET_REFERRER', {
          userName: item.userName,
          userId: item.userId,
        });
      }
    },
  },

  namespaced: true,
});
